import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../../notification.service';
import { RestService } from '../../rest.service';
@Component({
  selector: 'ngx-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  password1: String;
  password2: String;
  result: boolean;
  passwordMatch: boolean;
  token: String;

  // tslint:disable-next-line:max-line-length
  constructor(private activateRoute: ActivatedRoute, private restService: RestService, private router: Router,
     private notify: NotificationService, private spinner: NgxSpinnerService  ) { }

  ngOnInit() {
      this.activateRoute.params.subscribe((params) => {
          this.token = params['token'];
      });
  }

  validatePassword() {
      if (this.password1 != null) {
          const User = {
              password: this.password1,
          };
          let param =  "ValidatePassword" ;
          this.restService.postModel(User, `/screen/forgotPassword/${param}`).subscribe((response) => {
              this.result = response;
          });
      }
  }

  resetPassword() {
      if (this.password1 === this.password2) {
          this.passwordMatch = true;
          let User = {
              password: this.password1,
              passwordToken: this.token,
          };
          this.spinner.show();
          let param =  "ResetPassword" ;
          this.restService.postModel(User, `/screen/forgotPassword/${param}`).subscribe((response) => {
              if (response) {
                  User = null;
                  // this.showToast('Password Reset Successful !', 'success');
                  this.notify.showSuccess("Password Reset Successfully !", '');
                  this.router.navigateByUrl('/login');
              } else {
                  // this.showToast('Password Reset failed !', 'warning');
                  this.notify.showError("Password Reset failed !", '');
              }
              this.spinner.hide();
          });
      } else {
          this.passwordMatch = false;
      }
  }


  // showToast(content, status) {
  //     this.toastrService.show(content, 'status', { status });
  // }
}
